import { Component, OnInit } from '@angular/core';
import { ReportsService } from "../reports.service";
import { FileSaverService } from "../../shared/file-saver.servive";
import { DateHelperService } from "../../core/services/date-helper.service";
import { NotificationService } from "../../core/services/notification.service";
import { ReportTypes } from '../reports.enum';
import { FileType } from '../../shared/filetype.enum';

@Component({
  moduleId: module.id,
  selector: 'rejected-requests-report',
  template: `
<div>
  <svg class="icon xl clearfix">
      <use xlink:href='#med-circle-rejected' />
  </svg>
  <button class="button btn-main" (click)='downloadExcel()' title='Click to download report'>Rejected Requests Report</button>
</div>`
})

export class RejectedRequestsReportComponent {

  constructor(
    private reportsService: ReportsService,
    private fileSaverService: FileSaverService,
    private dateHelperService: DateHelperService,
    private notificationService: NotificationService) { }

    downloadExcel() {
      this.notificationService.showInfo('Please wait! Your report will be downloaded shortly.');
      let currentDate = new Date();
      let fileName = `Rejected Requests Report_${this.dateHelperService.formatDayAndMonth(currentDate)}`;
      let file = `${fileName}.xlsx`;
      this.reportsService.generateReportFile(currentDate, currentDate, fileName, ReportTypes.Requests, FileType.Excel).subscribe(
          (data: Blob) => this.fileSaverService.downloadFile(data, file),
          () => { },
          () => { }
      )
  }

}



// WEBPACK FOOTER //
// ./src/app/reports/rejected-requests-report/rejected-requests-report.component.ts